import '../styles/shared.scss'
import '../styles/variables.scss'

const CONTACT_EMAIL = 'funcionalbrothers@gmail.com'
const LAST_UPDATED = '16 de junio de 2025'

export default function Privacidad() {
  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '2rem 1.25rem 4rem' }}>
      <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.25rem', color: '#1f2937' }}>
        Política de Privacidad
      </h1>
      <p style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '2rem' }}>
        Última actualización: {LAST_UPDATED}
      </p>

      <Section title="1. Información general">
        <p>
          Esta Política de Privacidad describe cómo la aplicación (en adelante, «la App»)
          recopila, utiliza y protege la información personal de sus usuarios.
          Al utilizar la App, aceptas las prácticas descritas en este documento.
        </p>
        <p>
          El responsable del tratamiento de los datos puede ser contactado en:{' '}
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: '#2440ab' }}>{CONTACT_EMAIL}</a>.
        </p>
      </Section>

      <Section title="2. Datos que recopilamos">
        <p>Recopilamos los siguientes datos personales:</p>
        <ul>
          <li><strong>Datos de registro:</strong> nombre, apellidos y dirección de correo electrónico.</li>
          <li><strong>Foto de perfil:</strong> imagen que el usuario sube voluntariamente.</li>
          <li><strong>Datos de actividad:</strong> inscripciones a clases, eventos y categorías deportivas.</li>
          <li><strong>Datos de menores a cargo:</strong> nombre y apellidos de los hijos registrados por el usuario (opcional).</li>
          <li><strong>Token de notificaciones push:</strong> identificador del dispositivo para el envío de notificaciones.</li>
          <li><strong>Datos de uso:</strong> registros de acceso, interacciones con la App e historial de clases.</li>
        </ul>
        <p>No recopilamos datos de pago ni información bancaria.</p>
      </Section>

      <Section title="3. Finalidad del tratamiento">
        <p>Los datos se utilizan exclusivamente para:</p>
        <ul>
          <li>Gestionar la cuenta de usuario y autenticar el acceso.</li>
          <li>Permitir la inscripción y seguimiento de clases y eventos deportivos.</li>
          <li>Enviar notificaciones push relacionadas con la actividad del usuario en la App.</li>
          <li>Mostrar estadísticas de rendimiento y progreso deportivo.</li>
          <li>Comunicaciones internas entre entrenadores y usuarios.</li>
          <li>Mejorar el funcionamiento y la experiencia de la App.</li>
        </ul>
      </Section>

      <Section title="4. Base legal del tratamiento">
        <p>El tratamiento de los datos se basa en:</p>
        <ul>
          <li>
            <strong>Ejecución de un contrato:</strong> el tratamiento es necesario para prestar
            el servicio solicitado por el usuario (art. 6.1.b RGPD).
          </li>
          <li>
            <strong>Consentimiento:</strong> para el envío de notificaciones push y la
            publicación de foto de perfil (art. 6.1.a RGPD). El usuario puede retirar
            su consentimiento en cualquier momento.
          </li>
          <li>
            <strong>Interés legítimo:</strong> para el análisis de uso con fines de
            mejora del servicio (art. 6.1.f RGPD).
          </li>
        </ul>
      </Section>

      <Section title="5. Conservación de los datos">
        <p>
          Los datos se conservarán durante el tiempo que la cuenta del usuario esté activa.
          Una vez eliminada la cuenta, los datos se suprimirán en un plazo máximo de <strong>30 días</strong>,
          salvo que exista obligación legal de conservarlos por un período mayor.
        </p>
      </Section>

      <Section title="6. Transferencia de datos a terceros">
        <p>La App utiliza los siguientes servicios de terceros que pueden procesar datos personales:</p>
        <ul>
          <li>
            <strong>Google Firebase</strong> — para el envío de notificaciones push y análisis de uso.
            Política de privacidad: <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#2440ab' }}>firebase.google.com/support/privacy</a>
          </li>
          <li>
            <strong>Cloudinary</strong> — para el almacenamiento de imágenes de perfil.
            Política de privacidad: <a href="https://cloudinary.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#2440ab' }}>cloudinary.com/privacy</a>
          </li>
        </ul>
        <p>
          No vendemos, alquilamos ni cedemos datos personales a terceros con fines comerciales.
        </p>
        <p>
          Los datos pueden ser transferidos a servidores ubicados fuera del Espacio Económico
          Europeo. En tal caso, se garantizan las salvaguardas adecuadas conforme al RGPD
          (cláusulas contractuales tipo o decisiones de adecuación de la Comisión Europea).
        </p>
      </Section>

      <Section title="7. Derechos del usuario">
        <p>
          En virtud del Reglamento General de Protección de Datos (RGPD) y la legislación
          española aplicable, el usuario tiene derecho a:
        </p>
        <ul>
          <li><strong>Acceso:</strong> conocer qué datos personales se tratan.</li>
          <li><strong>Rectificación:</strong> corregir datos inexactos o incompletos.</li>
          <li><strong>Supresión («derecho al olvido»):</strong> solicitar la eliminación de sus datos.</li>
          <li><strong>Limitación del tratamiento:</strong> solicitar que se restrinja el uso de sus datos.</li>
          <li><strong>Portabilidad:</strong> recibir sus datos en un formato estructurado y legible por máquina.</li>
          <li><strong>Oposición:</strong> oponerse al tratamiento de sus datos en determinadas circunstancias.</li>
          <li>
            <strong>Retirada del consentimiento:</strong> revocar el consentimiento otorgado en cualquier
            momento, sin que ello afecte a la licitud del tratamiento previo.
          </li>
        </ul>
        <p>
          Para ejercer cualquiera de estos derechos, el usuario puede escribir a:{' '}
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: '#2440ab' }}>{CONTACT_EMAIL}</a>.
          Responderemos en el plazo máximo de <strong>30 días</strong>.
        </p>
        <p>
          Si considera que el tratamiento de sus datos no se ajusta a la normativa, puede
          presentar una reclamación ante la{' '}
          <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" style={{ color: '#2440ab' }}>
            Agencia Española de Protección de Datos (AEPD)
          </a>.
        </p>
      </Section>

      <Section title="8. Seguridad de los datos">
        <p>
          Adoptamos medidas técnicas y organizativas apropiadas para proteger los datos
          personales contra el acceso no autorizado, la pérdida, la destrucción o la
          divulgación accidental, incluyendo:
        </p>
        <ul>
          <li>Cifrado de contraseñas mediante algoritmos de hashing seguros (bcrypt).</li>
          <li>Comunicaciones cifradas mediante HTTPS/TLS.</li>
          <li>Autenticación mediante tokens JWT con caducidad.</li>
          <li>Acceso restringido a los datos según el rol del usuario.</li>
        </ul>
      </Section>

      <Section title="9. Menores de edad">
        <p>
          La App permite a los usuarios registrar datos de menores a su cargo (nombre y
          apellidos) con el único fin de gestionar su inscripción en actividades deportivas.
          El usuario que registre datos de un menor declara tener la patria potestad o
          tutela legal sobre dicho menor y consiente expresamente el tratamiento de sus datos.
        </p>
        <p>
          No recopilamos intencionadamente datos de menores de 14 años como usuarios
          directos de la App. Si detectamos que un menor ha creado una cuenta sin
          autorización, procederemos a eliminarla.
        </p>
      </Section>

      <Section title="10. Cookies y almacenamiento local">
        <p>
          La App utiliza <strong>almacenamiento local del navegador</strong> (localStorage)
          para mantener la sesión del usuario activa y almacenar preferencias básicas.
          No se utilizan cookies de seguimiento ni de publicidad.
        </p>
        <p>
          El token de notificaciones push del dispositivo se almacena localmente para
          identificar el dispositivo ante el servicio de notificaciones (Firebase Cloud Messaging).
        </p>
      </Section>

      <Section title="11. Cambios en esta política">
        <p>
          Nos reservamos el derecho de actualizar esta Política de Privacidad en cualquier
          momento. Cuando realicemos cambios significativos, notificaremos a los usuarios
          a través de la App o por correo electrónico. La fecha de la última actualización
          aparece al inicio de este documento.
        </p>
        <p>
          El uso continuado de la App tras la publicación de cambios constituye la aceptación
          de la nueva política.
        </p>
      </Section>

      <Section title="12. Contacto">
        <p>
          Para cualquier consulta relacionada con esta Política de Privacidad o con el
          tratamiento de tus datos personales, puedes contactar con nosotros en:
        </p>
        <p>
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: '#2440ab', fontWeight: 600 }}>
            {CONTACT_EMAIL}
          </a>
        </p>
      </Section>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: '2rem' }}>
      <h2 style={{
        fontSize: '1.1rem',
        fontWeight: 700,
        color: '#2440ab',
        marginBottom: '0.75rem',
        paddingBottom: '0.4rem',
        borderBottom: '2px solid #e8ecff',
      }}>
        {title}
      </h2>
      <div style={{
        fontSize: '0.93rem',
        lineHeight: 1.7,
        color: '#374151',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.6rem',
      }}>
        {children}
      </div>
    </section>
  )
}
